// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".send-message-history-table-component .confirm-btn[data-v-c9e9cb60]{width:64px}.send-message-history-table-component .overflow-hidden[data-v-c9e9cb60]{overflow:hidden!important;text-overflow:ellipsis;white-space:nowrap}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
